<template>
  <div class="container">
    <div v-html="htmlContent" class="html-container"></div>
  </div>
</template>

<script>
export default {
  name: 'HtmlStr',
  props: {
    htmlString: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      htmlContent: ''
    };
  },
  watch: {
    htmlString: {
      immediate: true,
      handler(newHtmlString) {
        let insideList = false;
        this.htmlContent = newHtmlString
          .map(line => {
            if (line.startsWith('#')) {
              line = line.slice(1); // Remove the '#' character
              return `<h1>${line}</h1>`;
            } else if (line.startsWith('{')) {
              insideList = true;
              return `<ul>`;
            } else if (line.startsWith('}')) {
              insideList = false;
              return `</ul>`;
            } else if (line.startsWith('.')) {
              line = line.slice(1); // Remove the '.' character
              return `<li>${line}</li>`;
            } else {
              return insideList ? `<li>${line}</li>` : `<p>${line}</p>`;
            }
          })
          .join('');
      }
    }
  },
  created() {
    console.log('HtmlStr component created');
  },
  mounted() {
    console.log('HtmlStr component mounted');
  },
  beforeUnmount() {
    console.log('HtmlStr component will be destroyed');
  }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
}

.html-container {
  width: 30%;
  padding: 20px;
  background-color: darkblue;
  color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: left; /* Left justify the text */
  border-radius: 15px; /* Rounded corners */
}

.html-container ul {
  list-style-type: disc; /* Use bullets for list items */
}
</style>
